import { tr } from '@app/i18n'
import { isParking } from '@app/rvf'
import { useState } from 'preact/hooks'
import { forgetCar, rememberCar, returnToCar } from '../car-actions'
import { importChunk } from '../lazy-retry'
import { anchorId, langTick, parkedCar, venue } from '../state'
import { GLYPH_CAR, GLYPH_PARKING, GLYPH_POSTCARD } from './glyphs'

/** Есть ли у текущего QR-якоря парковочная зона рядом (можно «запомнить»). */
function canRememberHere(): boolean {
  const v = venue.value
  const anchor = v?.anchors.find((a) => a.id === anchorId.value)
  if (!v || !anchor) return false
  return v.units.some((u) => u.level === anchor.level && isParking(v, u.category))
}

/** Плашка «Где моя машина» (идея №2): вернуться к сохранённой или запомнить. */
export function CarBar() {
  langTick.value
  const [hint, setHint] = useState(false)
  const car = parkedCar.value
  const v = venue.value
  if (!v) return null

  if (car) {
    const postcard = (): void => {
      void importChunk(() => import('../car-postcard')).then((m) => m.downloadCarPostcard(v, car))
    }
    return (
      <div class="car-bar">
        <button type="button" class="car-return" onClick={returnToCar}>
          <span class="glyph" aria-hidden="true" dangerouslySetInnerHTML={{ __html: GLYPH_CAR }} />{' '}
          {tr('car.return')}
        </button>
        <button
          type="button"
          class="car-forget"
          aria-label={tr('car.postcard')}
          title={tr('car.postcard')}
          onClick={postcard}
        >
          <span
            class="glyph"
            aria-hidden="true"
            dangerouslySetInnerHTML={{ __html: GLYPH_POSTCARD }}
          />
        </button>
        <button type="button" class="car-forget" aria-label={tr('car.forget')} onClick={forgetCar}>
          ✕
        </button>
      </div>
    )
  }

  if (!canRememberHere()) return null
  return (
    <div class="car-bar car-bar-col">
      <button
        type="button"
        class="car-save"
        onClick={() => {
          if (!rememberCar()) setHint(true)
        }}
      >
        <span
          class="glyph"
          aria-hidden="true"
          dangerouslySetInnerHTML={{ __html: GLYPH_PARKING }}
        />{' '}
        {tr('car.remember')}
      </button>
      {hint && <p class="car-hint">{tr('car.hint')}</p>}
    </div>
  )
}
